import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputRatingComponent } from '../../components/input-rating/input-rating.component';
import { ItemRatingComponent } from '../../components/item-rating/item-rating.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import UserRestServices from '../../services/user-rest.service';
import ServiceRestServices from '../../services/service-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-user-feedback',
	templateUrl: './modal-user-feedback.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, InputRatingComponent, ItemRatingComponent, FormsModule ]
})
export class ModalUserFeedbackComponent implements OnInit {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private dialogRef = inject(MatDialogRef<ModalUserFeedbackComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.handleModalInit();
		
		this.vm.handleModalClose = this.handleModalClose;
		this.vm.handleFormSubmit = this.handleFormSubmit;
		this.vm.handleReportInit = this.handleReportInit;
		this.vm.handleReportDestroy = this.handleReportDestroy;
		this.vm.onAliasChange = this.onAliasChange;
	}
	
	handleReportInit() {
		this.vm.isReporting = true;
		this.vm.isCommentRequired = true;
	}
	
	handleReportDestroy() {
		this.vm.isReporting = false;
		this.vm.isCommentRequired = false;
	}
	
	handleModalInit() {
		console.log('FEEDBACK', this.vm.subject);
		
		this.vm.user = this.session.getSession().user;
		this.vm.isDoctor = this.vm.user.businessUserType === 'SERVICE_PROVIDER';
		this.vm.data = {};
		this.vm.maxRating = 5;
		this.vm.maxCharacters = 500;
		this.vm.userInitials = this.vm.user.firstname + ' ' + this.vm.user.lastname;
		this.vm.data.alias = this.vm.userInitials;
		this.vm.isRatingDoctor = !this.vm.isDoctor;
		this.vm.subject = this.vm.subject;
		
		this.vm.occupation = this.vm.isRatingDoctor
			? this.vm.subject.occupation
			: this.angularFilterHelperService.translate('Common.Patient');
		this.vm.info = this.vm.isRatingDoctor
			? this.angularFilterHelperService.translate('Feedback.Info_Doctor')
			: this.angularFilterHelperService.translate('Feedback.Info_Patient');
		
		if (this.vm.isRatingDoctor) {
			this.getServiceDetails(this.vm.subject.userId);
		}
	}

	onAliasChange(value: string): void {
		const defaultAlias = this.vm.userInitials;
		if (value !== defaultAlias) {
			this.vm.aliasManuallyChanged = true;
		}
	}

	
	handleFormSubmit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid) return;
		
		if (this.vm.isRatingDoctor && !this.vm.isCommentRequired) {
			this.vm.isCommentRequired = true;
			return;
		}
		
		this.vm.loaderTimeout = this.angularHelperService.createTimer(() => { this.vm.processing = true; },
			this.config.getOtherConfig().LOADER_TIMEOUT_INIT);
		
		var payload: any = {
			user: {
				id: this.vm.subject.userId,
			},
			rating: this.vm.isRatingDoctor ? Number(this.vm.data.rating) : (this.vm.isReporting ? 1 : 0),
			comment: this.vm.data.comment,
			alias: this.vm.aliasManuallyChanged && this.vm.data.alias.trim() ? this.vm.data.alias : this.vm.userInitials
		};
		console.log('FEEDBACK.PAYLOAD', payload);
		
		this.userRestServices.sendBookingFeedback(payload,
			(res) => {
				this.handleFormComplete();
			},
			(err) => {
				console.log('FEEDBACK.ERROR', err);
			}
		);
	}
	
	handleFormComplete() {
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) {
			this.angularHelperService.createTimer(() => {
				this.handleFormSuccess();
			}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
		} else {
			this.handleFormSuccess();
		}
	}
	
	handleFormSuccess() {
		if (this.vm.isRatingDoctor && this.vm.isMentalService) {
			this.dialogRef.close({
				userId: this.vm.user.id,
				subject: this.vm.subject,
				isPatientEvaluatesSession: true
			});
		} else {
			this.vm.processing = false;
			this.vm.success = true;
		}
	}
	
	handleModalClose() {
		this.dialogRef.close();
	}
	
	getServiceDetails(userId) {
		this.serviceRestServices.getServiceByUserId({ userId: userId },
			(service) => {
				this.vm.service = service;
				this.vm.isMentalService = this.isMentalService(this.vm.service);
			}
		);
	}
	
	isMentalService(service) {
		if (service.subcategory == 'PSYCHOLOGY' ||
			service.subcategory == 'COACHING') {
			return true;
		}
		return false;
	}
	
}